import React from 'react';
import { Game as CommonGame } from 'js/components/common/Game';
import style from './index.scss';
import { compose, prop } from 'ramda';
import {
    branch,
    renderComponent,
    withProps } from 'recompose';
import OverflowGamesSlider from './OverflowGamesSlider';
import { usePortletConfig } from 'js/components/system/Portlet';

export const OverflowSlider = ({ gameCodes, showDivider, showGameInfo, showFeatureIcons = true, Game = CommonGame }) => (
    <div className={style.games}>
        {gameCodes.map(code =>
            <Game key={code}
                code={code}
                withFlexWidth={false}
                showGameInfo={showGameInfo}
                className={`${style.game} ${showDivider ? style.divider : ''}`}
                showFeatureIcons={showFeatureIcons}
            />
        )}
    </div>
);

export default compose(
    withProps(() => usePortletConfig(prop('config'))),
    branch(
        (config) => config.portletType === 'responsivegames',
        renderComponent(OverflowGamesSlider)
    )
)(OverflowSlider);
